import { HttpErrorResponse, HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MasterdosService {




  constructor(private httpService: HttpService, private http: HttpClient) { }
  getallDos(data: any) {

      const url = `${environment.SettingsApiendpoint}/master-dos-list?${data}`;

      return this.httpService.get(url, this.httpService.headers)
          .pipe(
              catchError(this.Errorhandling)
          );
  }
  editCustomerDos(data: any, id:any): Observable<any> {
    const url = `${environment.SettingsApiendpoint}/master-dos-edit/${id}`;
    return this.httpService.put(url, data, this.httpService.headers)
        .pipe(catchError(this.Errorhandling))
}

getSingleDosData(data: any) {
  const url = `${environment.SettingsApiendpoint}/master-dos-listbyID/${data}`;
  return this.httpService.get(url, this.httpService.headers)
      .pipe(
          catchError(this.Errorhandling)
      );
}
uploadFile(data:any, imagefile: File) {
  const url = `${environment.SettingsApiendpoint}/master-dos-import`;
  const formData = new FormData();
  formData.append('file', imagefile);
      formData.append('customer_id',data.customer_id);
      formData.append('provider_id',data.provider_id);

  return this.httpService
      .post(url, formData, this.httpService.headers)
      .pipe(catchError(this.Errorhandling));
}

downloadDos(data: any) {
  const url = `${environment.SettingsApiendpoint}/master-dos-export`;

  return this.httpService.get(url,this.httpService.headers);

}

  postMasterDos(data: any) {

    const url = `${environment.SettingsApiendpoint}/master-dos-add`
    return this.httpService.post(url, data, this.httpService.headers)
}
  deleteDos(id: any) {
    const url = `${environment.SettingsApiendpoint}/master-dos-delete/${id}`;

    return this.httpService.delete(url, this.httpService.headers)
        .pipe(catchError(this.Errorhandling))
}

  Errorhandling(err: HttpErrorResponse) {
    if (err.error instanceof ErrorEvent) {
        console.error(err.error.message);
    } else {
        console.error(`Backend returned code ${err.status}`);
    }
    return throwError('Please try again later.');
}
}
